import React from "react";

import "./index.scss";

const Select = ({
                    value,
                    onChange,
                    options = [],
                    labelKey = "label",
                    valueKey = "value",
                    placeholder = null,
                    className = "",
                    ...props
                }) => {
    return (
        <select value={value} onChange={onChange} className={className} {...props}>
            {placeholder && <option value="">{placeholder}</option>}
            {options.map((opt) => (
                <option key={opt[valueKey]} value={opt[valueKey]}>
                    {opt[labelKey]}
                </option>
            ))}
        </select>
    );
};

export default Select;
